import React, { useEffect, useState } from 'react'
import { message, Modal } from 'antd'

import { useDispatch, useSelector } from 'react-redux'
import styles from './PlayerModel.module.css'
import {
  selectShowPlayerModalStatus,
  selectVideoId,
  setShowPlayerModalStatus,
  setVideoId,
} from './PlayerModalSlice'
import Aliplayer from 'aliyun-aliplayer'
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css'
import { getVideoPlayerAuthRequest } from './PlayerModalApi'

var player

const PlayerModal = () => {
  const dispatch = useDispatch()
  const showStatus = useSelector(selectShowPlayerModalStatus)
  const videoId = useSelector(selectVideoId)
  useEffect(() => {
    playVideo(videoId)
    // return () => {
    //   if (player) {
    //     player = null
    //   }
    // }
  }, [showStatus, videoId]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  const handleCancel = () => {
    dispatch(setShowPlayerModalStatus(false))
    dispatch(setVideoId(''))
    if (player) {
      player.pause()
    }
  }

  function playVideo(videoUrl) {
    if (videoUrl) {
      getVideoPlayerAuthRequest(videoUrl, (data) => {
        if (
          'PlayAuth' in data &&
          data.PlayAuth != null &&
          data.PlayAuth != ''
        ) {
          if (player) {
            player.replayByVidAndPlayAuth(videoUrl, data.PlayAuth)
          } else {
            player = new Aliplayer(
              {
                id: 'player0',
                width: '100%',
                height: '100%',
                vid: videoUrl, // 必选参数。音视频ID。示例：1e067a2831b641db90d570b6480f****。
                playauth: data.PlayAuth, // 必选参数。音视频播放凭证。
                // authTimeout: 7200, // 播放地址的有效时长，单位：秒。该时长会覆盖在视频点播控制台设置的URL鉴权的有效时长。如果不传，则取默认值7200。如需设置此参数，请确保该时间大于视频的实际时长，防止播放地址在播放完成前过期。
              },
              function (player) {
                console.log('======。》》》是是是》》》》》')
                console.log('The player is created.')
              },
            )
          }
        } else {
          message.warning(data.msg)
        }
      })
    }
  }
  return (
    <Modal
      open={showStatus}
      // onOk={handleOk}
      onCancel={handleCancel}
      width={'50%'}
      footer={null}
    >
      <div className={styles.videoTag} id="player0"></div>
    </Modal>
  )
}

export default PlayerModal
